import { FieldRenderProps } from "react-final-form";

import TextInput from "./TextInput";

export type InputType = FieldRenderProps<string | any, HTMLElement>["input"];
export type MetaType = FieldRenderProps<string, HTMLInputElement>["meta"];

export default TextInput;
